import React, { useState, useContext, useEffect, useMemo } from "react";
import "../../styles/pages/form/FormPage.scss";
import { useForm, Controller, set } from "react-hook-form";
import { checkEmailExist, checkPhoneExist } from "../../api/apiManagement";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../models/ValidationSchema";
import useMediaQuery from "@mui/material/useMediaQuery";
import { countries, locations } from "../../data/Data";
import { FormContext } from "./Form";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  InputLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";
import { Popup } from "../../components/Popup";

function FormPage() {
  const { setCurrentStep, data, setData } = useContext(FormContext);
  const {
    register,
    handleSubmit,
    control,
    setError,
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      news_letters: data?.news_letters ? data.news_letters : "",
      first_name: data?.first_name ? data?.first_name : "",
      last_name: data?.last_name ? data?.last_name : "",
      select: data?.select
        ? { value: data?.select.value }
        : { value: "852", label: "+852" },
      country_code: "852",
      mobile_number: data?.mobile_number ? data?.mobile_number : "",
      email: data?.email ? data?.email : "",
      location: data?.location ? data?.location : "",
      privacy_policy: data?.privacy_policy ? true : false,
    },
    resolver: yupResolver(validationSchema),
  });

  const [isLoading, setIsLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [registeredInfo, setRegisteredInfo] = useState({
    location: "",
    email: "",
    phone: "",
    type: "",
  });
  // Nic Edited 20250115
  //const [maxLength, setMaxLength] = useState(countries[0].maxLength);
  const selectedCountryCode = watch("select.value");
  const maxLength = useMemo(() => {
    const currentSelectData = countries.find(
      (o) => o.value === selectedCountryCode
    );
    return currentSelectData.maxLength;
  }, [selectedCountryCode]);

  const matches = useMediaQuery("(max-width:480px)");
  const selectedNewsLetters = watch("news_letters");
  const selectedPrivacyPolicy = watch("privacy_policy");
  const fetchAreaCode = getValues("select.value");

  const displayOperationTime = () => {
    let Location_operation_hours = locations.find(
      (loc) => loc.value === getValues("location")
    );
    const { operationTimeTC, operationTimeEN } = Location_operation_hours;
    setData({
      ...data,
      operationTimeTC: operationTimeTC,
      operationTimeEN: operationTimeEN,
    });
  };

  useEffect(() => {
    displayOperationTime();
  }, [watch("location")]);

  const handleRadioChange = (field) => (event) => {
    const newValue = event.target.value;
    if (selectedNewsLetters === newValue) {
      setValue("news_letters", "");
    } else {
      field.onChange(event);
    }
  };

  const handleCheckPhoneExist = async (phone) => {
    const phoneLength = phone?.length;
    if (phoneLength >= 8) {
      setIsLoading(true);
      const currentPhone = fetchAreaCode + phone;
      setRegisteredInfo({});
      return checkPhoneExist({ phone: currentPhone })
        .then((res) => {
          const currentStatus = res.data.status;
          if (currentStatus === "200") {
            if (res.data.data !== "") {
              setOpenPopup(true);
              setRegisteredInfo({
                location: res.data.data,
                phone: phone,
                type: "phone",
              });
              return false;
            } else {
              return true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          return false;
        })
        .finally(() => {
          setIsLoading(false);
          return false;
        });
    }
    setIsLoading(false);
    return Promise.resolve(false);
  };

  const handleCheckEmailExist = async (email) => {
    console.log(email);
    const emailLength = email.length;
    if (emailLength >= 6) {
      setIsLoading(true);
      setRegisteredInfo({});
      return checkEmailExist({ email: email })
        .then((res) => {
          const currentStatus = res.data.status;
          if (currentStatus === "200") {
            if (res.data.data !== "") {
              setOpenPopup(true);
              setRegisteredInfo({
                location: res.data.data,
                email: email,
                type: "email",
              });
              return false;
            } else {
              return true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          return false;
        })
        .finally(() => {
          setIsLoading(false);
          return false;
        });
    } else {
      setIsLoading(false);
      return false;
    }
    setIsLoading(false);
    return Promise.resolve(false);
  };

  const onSubmit = async (d) => {
    console.log(d);

    // Run both checks concurrently
    const [phoneExists, emailExists] = await Promise.all([
      handleCheckPhoneExist(getValues("mobile_number")),
      handleCheckEmailExist(getValues("email")),
    ]);
    console.log(phoneExists);
    console.log(emailExists);

    // Proceed if both phone and email do not exist
    if (emailExists && phoneExists) {
      setData(d);
      setCurrentStep(1);
      console.log(data);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          marginBottom: "20px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Samsung Sharp Sans !important",
            fontSize: matches ? "16px" : "22px",
            marginBottom: "20px",
          }}
        >
          Pre order at Samsung Online Shop or Samsung Shop App, or pay a deposit
          at your chosen Samsung Experience Store{" "}
          <b>
            <u>on 9 February or before</u>
          </b>{" "}
          to confirm your pre-order and claim your exclusive offer for the new
          Galaxy S25 Series or Galaxy Book5 Series.
          <br />
          <br />
          立即登記，並
          <b>
            <u>於2月9日或之前</u>
          </b>
          ，於Samsung 網上商店、Samsung Shop App預訂全新 Galaxy S25 系列或
          Galaxy
          Book5系列，或親臨您所選擇的三星專門店，繳付訂金以確認預訂及獲取限定禮遇。
        </Typography>
        <Typography variant="subtitle2">
          All fields marked with (<span className="red">*</span>) are mandatory.
          <br />
          所有 (<span className="red">*</span>) 項目必須填寫。
        </Typography>
      </Box>

      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: matches ? "column" : "row",
        }}
      >
        <Box
          sx={{
            width: "100%",
            marginRight: matches ? "0px" : "20px",
            marginBottom: matches ? "10px" : "30px",
          }}
        >
          <InputLabel htmlFor="last_name">
            <span className="label-container">
              <span className="red">*</span>
              Last Name
              <br></br>
              姓氏
            </span>
          </InputLabel>
          <TextField
            fullWidth
            variant="standard"
            error={!!errors.last_name}
            disabled={isLoading}
            {...register("last_name")}
          />

          {errors.last_name && (
            <FormHelperText error>
              * Please input last name
              <br></br>* 請輸入姓氏
            </FormHelperText>
          )}
        </Box>
        <Box
          sx={{
            width: "100%",
            marginLeft: matches ? "0px" : "20px",
            marginBottom: matches ? "10px" : "30px",
          }}
        >
          <InputLabel htmlFor="first_name">
            <span className="label-container">
              <span className="red">*</span>
              First Name <br></br>
              名字
            </span>
          </InputLabel>
          <TextField
            fullWidth
            variant="standard"
            error={!!errors.first_name}
            disabled={isLoading}
            {...register("first_name")}
          />

          {errors.first_name && (
            <FormHelperText error>
              * Please input first name
              <br></br>* 請輸入名字
            </FormHelperText>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: matches ? "column" : "row",
        }}
      >
        <Box
          sx={{
            width: "100%",
            marginRight: matches ? "0px" : "20px",
            marginBottom: matches ? "10px" : "30px",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <InputLabel htmlFor="mobile_number">
              <span className="label-container">
                <span className="red">*</span>
                Mobile Number
                <br></br>
                (To receive WhatsApp messages)
                <br></br>
                流動電話號碼
                <br></br>
                (可接收 WhatsApp 訊息)
              </span>
            </InputLabel>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Controller
                control={control}
                name="select.value"
                render={({ field }) => (
                  <Select
                    error={!!errors.mobile_number}
                    {...field}
                    labelId="country-code-label"
                    displayEmpty
                    defaultValue={
                      data?.select?.value
                        ? data?.select?.value
                        : countries[0].value
                    }
                    variant="standard"
                    disabled={isLoading}
                    {...register("select.value")}
                    // Nic Edited 20250115
                    // onChange={(event) => {
                    //   const selectedCountry = countries.find(
                    //     (country) => country.value === event.target.value
                    //   );

                    //   console.log('123321', event.target.value)
                    //   //setMaxLength(selectedCountry.maxLength); // Update maxLength based on selected country
                    //   field.onChange(event.target.value);
                    // }}
                  >
                    {countries.map((country) => (
                      <MenuItem key={country.value} value={country.value}>
                        {country.label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              <TextField
                fullWidth
                variant="standard"
                slotProps={{
                  htmlInput: {
                    maxLength,
                    onBlur: () =>
                      handleCheckPhoneExist(getValues("mobile_number")),
                  },
                }}
                error={!!errors.mobile_number}
                disabled={isLoading}
                {...register("mobile_number")}
              />
            </Box>
          </Box>
          {errors.mobile_number && (
            <FormHelperText error>
              * Please input valid mobile number (That can receive WhatsApp
              messages)<br></br>* 請輸入有效流動電話號碼 (可接收 WhatsApp 訊息)
            </FormHelperText>
          )}
        </Box>
        <Box
          sx={{
            width: "100%",
            marginLeft: matches ? "0px" : "20px",
            marginBottom: matches ? "10px" : "30px",
          }}
        >
          <InputLabel htmlFor="email">
            <span className="label-container">
              <span className="red">*</span>
              Email Address <br></br> 電郵地址
            </span>
          </InputLabel>
          <TextField
            fullWidth
            variant="standard"
            inputProps={{
              onBlur: () => handleCheckEmailExist(getValues("email")),
            }}
            error={!!errors.email}
            disabled={isLoading}
            {...register("email")}
          />
          {errors.email && (
            <FormHelperText error>
              * Please input valid email address
              <br></br>* 請輸入有效電郵地址
            </FormHelperText>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          marginRight: matches ? "0px" : "20px",
          marginBottom: "20px",
        }}
      >
        <InputLabel htmlFor="select" sx={{ marginBottom: "20px" }}>
          <span className="label-container">
            <span className="red">*</span>
            Pre-order at Samsung Online Shop / Samsung Experience Store<br></br>
            於Samsung 網上商店/ 三星專門店預訂
          </span>
        </InputLabel>

        <Controller
          name="location"
          control={control}
          defaultValue=""
          render={({ field, onChange }) => (
            <Select
              notched
              {...field}
              className="select-input"
              labelId="select-label"
              displayEmpty
              disabled={isLoading}
              error={!!errors.location}
              defaultValue={
                data?.location ? data?.location : locations[0].value
              }
            >
              {locations.map((location, key) => (
                <MenuItem
                  key={location.value}
                  value={location.value}
                  disabled={key === 0}
                >
                  <span
                    dangerouslySetInnerHTML={{ __html: location.label }}
                  ></span>
                </MenuItem>
              ))}
            </Select>
          )}
        />
        <Typography
          variant="subtitle2"
          sx={{ color: "rgba(0, 0, 0, 0.6)", marginTop: "10px" }}
        >
          {data?.operationTimeTC}
          <br />
          {data?.operationTimeEN}
        </Typography>

        {errors.location && (
          <FormHelperText error>
            * Please select a store<br></br> * 請選擇一間分店
          </FormHelperText>
        )}
      </Box>

      <Box sx={{ widows: "100%", height: "100%" }}>
        <Box sx={{ marginBottom: "30px" }}>
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <Checkbox
              disabled={isLoading}
              {...register("privacy_policy")}
              sx={{
                paddingTop: "0",
                color: !!errors.privacy_policy ? "#d32f2f" : "",
              }}
              checked={selectedPrivacyPolicy === true ? true : false}
            />
            <FormHelperText>
              <span className="label-container">
                <span className="red">*</span>
                <span>
                  I understand and agree that the personal data provided herein
                  will be collected and used by Samsung Electronics H.K. Company
                  Limited (“Samsung”) for the purposes directly related to this
                  event (including but not limited to confirming registration
                  and receiving notifications pertaining to this event) and
                  (optional and subject to separate consent sought from me) for
                  Samsung’s any other future marketing promotion and/or direct
                  marketing purposes. I further understand that such personal
                  data may be transferred to Samsung’s affiliates and/or its
                  third party service providers (whether in Hong Kong or abroad)
                  (collectively "Data Users") where necessary for the above
                  purposes. I acknowledge that Samsung will process my personal
                  data in compliance with the requirements of Personal Data
                  (Privacy) Ordinance and{" "}
                  <a
                    style={{
                      color: "rgba(0, 0, 0, 0.6)",
                      textDecoration: "underline",
                    }}
                    href="https://www.samsung.com/hk_en/info/privacy"
                    target="_blank"
                  >
                    Samsung Privacy Policy
                  </a>
                  , and that I have the right to request access to and
                  correction of my personal data held by Data Users, and such
                  request can be made to Samsung’s Data Privacy Officer at
                  privacy.sehk@samsung.com.
                  <br></br>
                  <br></br>
                  我了解並同意上述所提供的個人資料將由三星電子香港有限公司(「Samsung」)所收集、使用及保留用作與此活動直接相關的目的（包括但不限於確認我的登記及接收有關本活動的通知）及（在另行獲得我在可選填項目表示同意下）供Samsung作日後任何其他宣傳推廣及/或直接促銷目的。我明白我所提供的個人資料在需要時可能會轉交Samsung的關聯公司及/或其第三方服務供應商
                  ( 無論在香港或海外） ( 統稱 「使用方」
                  )以作上述用途。我明白Samsung將根據《個人資料（私隱）條例》
                  <a
                    style={{
                      color: "rgba(0, 0, 0, 0.6)",
                      textDecoration: "underline",
                    }}
                    href="https://www.samsung.com/hk/info/privacy"
                    target="_blank"
                  >
                    Samsung的私隱政策
                  </a>
                  處理我的個人資料，亦明白本人有權查閱及改正使用方所持關於本人的個人資料，並能透過
                  privacy.sehk@samsung.com 聯絡Samsung
                  的資料私隱主任以提出該等要求。
                </span>
              </span>
            </FormHelperText>
          </Box>
          {errors.privacy_policy && (
            <FormHelperText error>
              * 請同意條款及細則及私隱政策<br></br>* Please agree to the Terms &
              Conditions and the Privacy Policy
            </FormHelperText>
          )}
        </Box>
        <Box sx={{ height: "100%" }}>
          <Box sx={{ display: "flex" }}>
            <Box sx={{ margin: "24px" }}></Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <FormHelperText>
                I would like to receive special offers, promotional and
                marketing information about Samsung products, services and/or
                events of Samsung Electronics H.K. Company, Limited (“Samsung”),
                through push notifications, e-newsletters, WhatsApp and SMS/MMS
                etc. I understand and agree that Samsung will use my personal
                data provided herein for the aforesaid direct marketing purposes
                according to Samsung's Privacy Policy. I understand that Samsung
                may not so use my personal data without my consent. And my
                preferred language is:
                <br></br> <br></br>
                本人希望透過推送通知、短信、WhatsApp 訊息及電子報等 ,
                收取三星電子香港有限公司(「Samsung」)發出有關Samsung產品、服務及/或活動的特別優惠及市場推廣訊息
                。本人明白及同意Samsung將根據其私隱政策使用我上述所提供的個人資料作相關的直接促銷用途。我知悉在未經我的同意下，Samsung不得如此使用我的個人資料。我選擇的語言為:
              </FormHelperText>
              <Controller
                name="news_letters"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <RadioGroup
                    {...field}
                    value={selectedNewsLetters}
                    sx={{ display: "flex", flexDirection: "row" }}
                  >
                    <FormControlLabel
                      value="hk"
                      label="Traditional Chinese 繁體中文"
                      sx={{ color: "rgba(0, 0, 0, 0.6)" }}
                      slotProps={{ typography: { variant: "subtitle2" } }}
                      control={
                        <Radio
                          onClick={handleRadioChange(field)}
                          checked={selectedNewsLetters === "hk"}
                          disabled={isLoading}
                        />
                      }
                    />
                    <FormControlLabel
                      value="hk_en"
                      label="English 英文"
                      sx={{ color: "rgba(0, 0, 0, 0.6)" }}
                      slotProps={{ typography: { variant: "subtitle2" } }}
                      control={
                        <Radio
                          onClick={handleRadioChange(field)}
                          checked={selectedNewsLetters === "hk_en"}
                          disabled={isLoading}
                        />
                      }
                    />
                  </RadioGroup>
                )}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <LoadingButton
          type="submit"
          variant="outlined"
          onClick={handleSubmit(onSubmit)}
          sx={{ borderRadius: "30px", lineHeight: "20px", width: "140px" }}
          disabled={isLoading}
        >
          Next Step<br></br>
          下一步
        </LoadingButton>
      </Box>
      <Popup
        open={openPopup}
        checkType={registeredInfo.type}
        phone={registeredInfo.phone}
        email={registeredInfo.email}
        location={registeredInfo.location}
        onClose={() => setOpenPopup(false)}
      />
    </Box>
  );
}

export default FormPage;
